import { render, staticRenderFns } from "./SurveyQuestionsView.vue?vue&type=template&id=bba39a96&scoped=true"
import script from "./SurveyQuestionsView.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionsView.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestionsView.vue?vue&type=style&index=0&id=bba39a96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba39a96",
  null
  
)

export default component.exports